import ArrowForwardOutlined from '@icons/ArrowForwardOutlined';
import { GetCampaignResponse, UserNotification } from '@types';
import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { isCampaignViewable } from '../CampaignCreator/campaignStatus';
import BaseCampaignNotification from './BaseCampaignNotification';
import { isValidCampaign } from './NavbarMailboxCampaignPermissionsNotification';

export interface NavbarMailboxCampaignAccessNotificationProps {
  notification: UserNotification;
  onNavigate: (id: string) => void;
}

const NavbarMailboxCampaignAccessNotification = ({ notification, onNavigate }: NavbarMailboxCampaignAccessNotificationProps) => {
  const navigate = useNavigate();
  const campaign_id = isValidCampaign(notification.data) ? notification.data.campaignId : null;

  const onClicked = useCallback(() => {
    navigate(`/campaign/${campaign_id}`);
    onNavigate(notification.id);
  }, [campaign_id, navigate, notification.id, onNavigate]);

  const renderMessage = useCallback((campaignName: string) => {
    return `You have been granted access to the campaign "${campaignName}".`;
  }, []);

  const showActionButton = useCallback((data: GetCampaignResponse | null) => {
    return Boolean(data && isCampaignViewable(data) && data.warming_identifier);
  }, []);

  return (
    <BaseCampaignNotification
      notification={notification}
      onNavigate={onNavigate}
      campaignId={campaign_id}
      notificationType="Campaign access"
      renderMessage={renderMessage}
      actionIcon={<ArrowForwardOutlined />}
      onAction={onClicked}
      showActionButton={showActionButton}
    />
  );
};

export default memo(NavbarMailboxCampaignAccessNotification);
